import BaseServiceV2 from "../BaseServiceV2";
import ApiUrl from '../ApiUrl';

class BasvurularService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.IKIseAlimDomain + ApiUrl.controller.Basvurular);
    }

    async GetBasvuruDurum(data) {
        return await this.easyGet(ApiUrl.endpoint.GetBasvuruDurum, data);
    }

    async getBasvuruCVPDF(data) {
        return await this.easyPost(ApiUrl.endpoint.getBasvuruCVPDF, data);
    }

    async getBasvuruPmaCVPDF(data) {
        return await this.easyPost(ApiUrl.endpoint.getBasvuruPmaCVPDF, data);
    }

    async BasvuruAdayOlumSuz(data) {
        return await this.easyPost(ApiUrl.endpoint.BasvuruAdayOlumSuz, data);
    }
}

const Basvurularservice = new BasvurularService();

export default Basvurularservice;
